import React, { useState, useEffect } from "react";
import { Box, Typography, Fade, useMediaQuery, useTheme } from "@mui/material";
import Header from "../Header";
import Footer from "../Footer";
import { AboutUs } from "./AboutUs";
import { Features } from "./Features";
import { BrandCasting } from "./BrandCasting";
import { Organization } from "./Organization";
import { getStaticFileUrl } from "../utils/config";
import { Location } from "./Location";
import { ScrollToTopButton } from "../ScrollToTopButton";
import Portfolio from "./Portfolio";
import { OurValues } from "./OurValues";


export const About = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [fadeIn, setFadeIn] = useState(false);

  useEffect(() => {
    const timeout = setTimeout(() => setFadeIn(true), 250); // 0.4초 후 콘텐츠 페이드 인 시작
    return () => clearTimeout(timeout); // 컴포넌트 언마운트 시 타이머 정리
  }, []);

  return (
    <Box sx={{ overflowX: "hidden" }}>
      {/* 헤더는 즉시 렌더링 */}
      <Header />
      <Box
        component="header"
        sx={{
          width: "100%", // 부모 너비에 맞춤
          height: "55vh",
          textAlign: "center",
          alignItems: "center",
          justifyContent: "center",
          color: "rgb(0, 0, 0)",
          paddingTop: "120px",
          marginBottom: "30px",
          overflow: "hidden", // 넘치는 글자가 보이지 않도록 설정
          backgroundSize: "cover",
          backgroundPosition: "center top",
          backgroundRepeat: "no-repeat",
          backgroundImage: `
        linear-gradient(
          rgba(0, 0, 0, 0.75), 
          rgba(0, 0, 0, 0.75)
        ), 
        url(${getStaticFileUrl('/img/about/banner.png')})
      `,
        }}
      >
        <Box
          component="img"
          src={getStaticFileUrl("/img/logo.png")}
          alt="Logo"
          sx={{
            marginTop: "4rem",
            width: "230px",
            height: "auto",
            marginBottom: "1.5rem",
            "@media (max-width: 960px)": {
              width: "140px",
            },
            "@media (max-width: 600px)": {
              width: "140px",
            },
            animation: "slideUp 0.5s ease-out forwards",
            animationDelay: "0.1s", // 부제목 애니메이션 딜레이
            "@keyframes slideUp": {
              from: {
                transform: "translateY(100%)", // 완전히 안보이는 위치에서 시작
              },
              to: {
                transform: "translateY(0)", // 원래 위치
              },
            },
          }}
        />
        {/* 세로 구분선 */}
        <Box
          sx={{
            width: "1px", // 선 너비
            height: "2.5rem", // 선 높이
            background: "#fff",
            margin: "0 auto 15px", // 중앙 정렬 및 아래 간격
            borderRadius: "2px", // 부드러운 모서리
            animation: "slideUp 0.5s ease-out forwards",
            animationDelay: "0.1s", // 부제목 애니메이션 딜레이
            "@keyframes slideUp": {
              from: {
                transform: "translateY(100%)", // 완전히 안보이는 위치에서 시작
              },
              to: {
                transform: "translateY(0)", // 원래 위치
              },
            },
          }}
        />
        {/* 부제목 */}
        <Box
          sx={{
            overflow: "hidden", // 부제목 애니메이션 영역 제한
          }}
        >
          <Typography
            sx={{
              fontSize: isMobile ? "1.1 rem" : "1.5rem", // 부제목 크기
              padding: "10px 0", // 위아래 간격
              color: "#fff",
              fontWeight: "300",
              animation: "slideUp 0.5s ease-out forwards",
              animationDelay: "0.1s", // 부제목 애니메이션 딜레이
              "@keyframes slideUp": {
                from: {
                  transform: "translateY(100%)", // 완전히 안보이는 위치에서 시작
                },
                to: {
                  transform: "translateY(0)", // 원래 위치
                },
              },
            }}
          >
            씨유미디어그룹은 클라이언트의 가치를 높이고,
            <br />
            비즈니스를 성장시키는 "종합 브랜드 마케팅 회사" 입니다.
          </Typography>
        </Box>
      </Box>
      {/* 나머지 콘텐츠는 추가 페이드 인 */}
      <Fade in={fadeIn} timeout={800}>
        <Box>
          <AboutUs />
          <OurValues/>
          <Portfolio/>
          <Organization />
        </Box>
      </Fade>
      <Footer />
      <ScrollToTopButton />
    </Box>
  );
};
